export default __webpack_public_path__ + "static/media/preview-dashboard.5b7e33eb.png";